module.exports = __webpack_public_path__ + "static/media/typec.41cb1420.jpg";